<template lang="pug">
  v-row
    v-col(cols="12")
      v-list-item(class="pl-0")
        v-list-item-content
          v-list-item-title
            h2.mb-2
              span(v-if="!task") Ответы
              span(v-else) {{ task.title }}

            template(v-if="task")
              p(v-html="task.description")
    v-fade-transition(leave-absolute)
      v-col(
        v-if="loading.init"
        cols=12
      )
        v-skeleton-loader(
          type="card@3"
        )
    v-col(
      v-if="!loading.init"
      cols=12
    )
      p(
        v-if="!filterAnswer.length"
      ) Данное задание не содержит данных для проверки
      v-tabs(
        v-else
        v-model="tab"
      )
        v-tab Результат
        v-tab(v-if="showAnalytic") Аналитика
      v-tabs-items(
        v-model="tab"
      )
        v-sheet.py-4.px-2.sdo-radius
          v-tab-item
            v-card(
              v-for="answer in filterAnswer"
              :key="answer.id" class=""
            ).sdo-card.mb-4.px-2
              v-card-title {{ answer.task_unit.title }}
              v-card-text.pb-0(v-html="answer.task_unit.description")
              task-unit-type-wrap(
                :task-unit="answer.task_unit"
                #default="{ component }"
              )
                component(
                  :is="component"
                  :value="answer"
                )
          v-tab-item
            v-card(
              v-for="answer in filterAnswer"
              :key="answer.id"
            ).sdo-card.mb-4.px-2
              v-card-title {{ answer.task_unit.title }}
              v-card-text.pb-0(v-html="answer.task_unit.description")
              task-unit-type-wrap(
                :task-unit="answer.task_unit"
                :answer="answer"
                #default="{ component, value }"
              )
                component(
                  :task="task"
                  :is="component"
                  :value="value"
                  analytic
                )

      task-check-mark(
        v-if="filterAnswer.length && canMark"
        :task-id="Number(taskId)"
        :group-id="Number(groupId)"
        :user-id="Number(userId)"
        :journal-id="Number(filterAnswer[0].journal_id)"
        :knowledgeBaseId="knowledgeBaseId"
        :answerForGpt="answerForGpt"
      )

</template>

<script>
import TaskCheckMark from '@/modules/Groups/components/TaskCheckMark.vue';
import TaskUnitTypeWrap from '@/modules/Groups/components/TaskUnitTypeWrap.vue';
import { TASK_UNIT_TYPE_NAMES } from '@/modules/Tasks/TaskUnits/constants';

export default {
  name: 'TaskCheck',
  components: { TaskCheckMark, TaskUnitTypeWrap },
  data: () => ({
    answers: [],
    task: null,
    knowledgeBaseId: null,
    loading: {
      init: true,
    },
    tab: null,
  }),
  computed: {
    showAnalytic() {
      const noShowTypes = [TASK_UNIT_TYPE_NAMES.file, TASK_UNIT_TYPE_NAMES.link];
      return this.task.task_units.filter(({ type }) => !noShowTypes.includes(type)).length;
    },
    taskId() {
      return this.$route.params.id;
    },
    groupId() {
      return this.$route.query.group;
    },
    userId() {
      return this.$route.query.user;
    },
    lastJournal() {
      return Math.max(...this.answers.map((i) => i.journal_id));
    },
    canMark() {
      if (!this.$route.query.journal) return true;
      return (+this.$route.query.journal === this.lastJournal);
    },
    filterAnswer() {
      const journal = this.$route.query.journal || this.lastJournal;
      return this.answers.filter((item) => item.journal_id === +journal);
    },
    answerForGpt() {
      if (this.filterAnswer.length === 1 && this.filterAnswer[0].task_unit.type === 3) {
        return this.filterAnswer[0];
      }
      return null;
    },
  },
  async created() {
    this.loading.init = true;
    await Promise.all([
      this.getAnswers(),
      this.fetchTask(),
    ]);
    // if (this.answerForGpt) this.fetchGptSettings();
    this.loading.init = false;
  },
  methods: {
    async fetchTask() {
      const resp = await this.$api.tasks.tasksStatisticsShow(this.taskId);
      this.task = resp.data.data;
      return resp;
    },
    async getAnswers() {
      const resp = await this.$api.tasks.getTaskAnswers(this.taskId, this.groupId, this.userId);
      this.answers = resp.data.data;
      return resp;
    },
    async fetchGptSettings() {
      const params = { 'search[task_id]': this.taskId };
      const { data } = await this.$api.gptPulse.getTaskGptSettings({ params });
      const [item] = data.data;
      this.knowledgeBaseId = item && item.knowledge_base_id;
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep table, ::v-deep th, ::v-deep td {
  border: 1px solid;
}
</style>
